// Фронт и API всегда на одном домене: nginx проксирует /auth, /servers, /data.
// REACT_APP_API_URL нужен только для локальной разработки.
export const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;
